import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { ComponentProps } from 'ui/common';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { Icon } from 'ui/common/icon';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { ChildEntityCountShape } from 'app/area/case/selectors';

interface FactItemInvolvedPersonInsideProps extends ComponentProps, FactItemProps {
  numberOfInvolvedPersonsInside: ChildEntityCountShape;
  [key: string]: any;
}

export const InvolvedPersonInsideFactItem = (props: FactItemInvolvedPersonInsideProps) => {
  const { tooltip, title, numberOfInvolvedPersonsInside, url, linkDomain, portalTarget } = props;
  const iconAbsolutePath = toAbsoluteUrl('i/entry-icon.svg');
  const iconInvolvedPersonsInside = <Icon url={iconAbsolutePath} />;
  const items = [
    { value: numberOfInvolvedPersonsInside?.count, tooltip }
  ]; 


  if (!numberOfInvolvedPersonsInside?.count) {
    return null;
  }
  
  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}>
    <BadgeList
      icon={iconInvolvedPersonsInside}
      title={title}
      valueItems={items}
      useNestedIndicator={true}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
